"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUKAddressDetails = exports.getUKAddressList = exports.getCompanyDetailsByVAT = exports.getGeoLocation = exports.getAddresses = exports.getUsStates = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const common_utils_1 = require("@as-react/common-utils");
const createUrl_1 = require("../../utils/createUrl");
const generalEndpoints = {
    USStates: {
        client: 'api/general/county/country',
    },
    addresses: {
        client: 'api/aem/general/postal/{postalCode}/{houseNumber}',
    },
    getGeoLocation: {
        client: 'api/aem/general/geocode/components',
    },
    companyDetailsByVAT: {
        client: 'api/general/vat/validate',
    },
    UKAddressList: {
        client: 'api/aem/general/postal/v2/uk/search',
    },
    UKAddressDetails: {
        client: 'api/aem/general/postal/v2/uk/format',
    },
};
const getUsStates = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { countryId }) {
    if (!countryId) {
        return [];
    }
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, generalEndpoints.USStates, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { countryId }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getUsStates = getUsStates;
const getAddresses = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { countryId, postalCode, houseNumber }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, generalEndpoints.addresses, isServer, {
        postalCode,
        houseNumber,
    });
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { countryId, language: undefined }),
    };
    const result = yield axios_1.default.request(axiosConfig);
    if ('addresses' in result.data) {
        return result.data.addresses.map(address => {
            if (address.city) {
                address.city = (0, common_utils_1.capitalize)(address.city);
            }
            return address;
        });
    }
    return result.data;
});
exports.getAddresses = getAddresses;
const getGeoLocation = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { countryCode, location }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, generalEndpoints.getGeoLocation, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            countryCode,
            languageCode: defaultRequestParams.language,
            addressQuery: location,
        },
        withCredentials: true,
    };
    const answer = yield axios_1.default.request(axiosConfig);
    return answer.data;
});
exports.getGeoLocation = getGeoLocation;
const getCompanyDetailsByVAT = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { vatNumber, country }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, generalEndpoints.companyDetailsByVAT, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { vatnumber: vatNumber, country }),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getCompanyDetailsByVAT = getCompanyDetailsByVAT;
const getUKAddressList = (_a, _b, _c) => tslib_1.__awaiter(void 0, [_a, _b, _c], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { term, size }, { signal }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, generalEndpoints.UKAddressList, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        signal,
        params: Object.assign(Object.assign({}, defaultRequestParams), { term, size }),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data.pickList;
});
exports.getUKAddressList = getUKAddressList;
const getUKAddressDetails = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { moniker }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, generalEndpoints.UKAddressDetails, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { moniker }),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getUKAddressDetails = getUKAddressDetails;
//# sourceMappingURL=general.api.js.map